import React from 'react'

const SvgCase = props => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.fill}
      fillRule="evenodd"
      d="M29.333 16v-5.333A2.668 2.668 0 0 0 26.667 8H5.333a2.67 2.67 0 0 0-2.666 2.667V16a2.668 2.668 0 0 0 2.666 2.667h21.334A2.67 2.67 0 0 0 29.333 16zm-2.666 13.333a2.67 2.67 0 0 0 2.666-2.666v-6.074c-.786.459-1.69.74-2.666.74v8zM8 29.333h16v-8H8v8zm-5.333-2.666a2.668 2.668 0 0 0 2.666 2.666v-8c-.976 0-1.88-.281-2.666-.74v6.074zm12-24A2.67 2.67 0 0 0 12 5.333h8a2.67 2.67 0 0 0-2.667-2.666h-2.666zm12 2.666A5.334 5.334 0 0 1 32 10.667v16A5.334 5.334 0 0 1 26.667 32H5.333A5.334 5.334 0 0 1 0 26.667v-16a5.334 5.334 0 0 1 5.333-5.334h4A5.334 5.334 0 0 1 14.667 0h2.666a5.334 5.334 0 0 1 5.334 5.333h4zm-9.334 8c.734 0 1.334.6 1.334 1.334 0 .733-.6 1.333-1.334 1.333h-2.666c-.734 0-1.334-.6-1.334-1.333 0-.734.6-1.334 1.334-1.334h2.666z"
    />
  </svg>
)

export default SvgCase
